import { render, staticRenderFns } from "./DataTableColumn.vue?vue&type=template&id=82d90398&"
import script from "./DataTableColumn.vue?vue&type=script&lang=ts&"
export * from "./DataTableColumn.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports